export const getStrapiImage = (image) => {
  return image?.data?.attributes?.url || "";
};
